import styled from 'styled-components';

export const AissLabelIcon = styled.div`
  position: relative;
  top: 18px;
  margin-right: 29px;
  background: transparent;
  height: 14px;
  box-sizing: border-box;
  border: none;
  box-shadow: none;
  &:before {
    position: absolute;
    content: '';
    width: 5%;
    left: 0px;
    height: 3px;
    z-index: -1;
    transform: perspective(11px) rotateX(52deg);
    border: ${(props) => {
      return `8px solid ${props.color}`;
    }};
    border-bottom: none;
    margin-top: -21px;
    border-radius: 1.5px;
  }
  &::after {
    position: absolute;
    content: '';
    width: 5%;
    left: 0px;
    height: 3px;
    z-index: -1;
    top: 10px;
    transform: perspective(11px) rotateX(-52deg);
    border: ${(props) => {
      return `8px solid ${props.color}`;
    }};
    border-top: none;
    margin-top: -21px;
    border-radius: 1.5px;
  }
`;
